export const FILTERSELECT = {
  FIELD_LABEL: "name",
  FIELD_VALUE: "id",
};
